module.exports = __webpack_public_path__ + "static/media/league-cert.8205c2a8.png";